import { Box, Tooltip } from '@mui/material'
import { observer } from 'mobx-react'
import React, { FC } from 'react'
import TableBodyCell from '../TableBodyCell'
import { getBoxStyles } from './style'

interface StatusCellProps {
  tooltipName: string
  src: string | null
  backgroundColor?: string
}

const StatusCell: FC<StatusCellProps> = ({
  tooltipName,
  src,
  backgroundColor,
}) => {
  return (
    <TableBodyCell backgroundColor={backgroundColor}>
      <Box sx={getBoxStyles()}>
        <Tooltip title={tooltipName} placement='top-start'>
          <img src={src || undefined} alt='Status icon' />
        </Tooltip>
      </Box>
    </TableBodyCell>
  )
}

export default observer(StatusCell)
